// Тексты окна «Начало работы»: шаги чеклиста и ссылки на ресурсы. Отметки шагов — на сервере (/api/onboarding).

import { t } from "@/lib/i18n";

export type OnboardingStep = {
  id: string;
  icon: string;
  title: string;
  text: string;
  cta: string;
  bullets: string[];
  visual: boolean;
};

export const onboardingSteps: OnboardingStep[] = [
  {
    id: "channels",
    icon: "ri-share-forward-line",
    title: t("Подключите каналы, чтобы объединить переписку и звонки"),
    text: t("Общайтесь с клиентами в WhatsApp, Messenger, Telegram и TikTok — все каналы собираются в Hub в единой ленте входящих."),
    cta: t("Подключить канал"),
    bullets: [t("WhatsApp по QR-коду, Telegram по токену"), t("Почта и звонки в том же окне")],
    visual: true,
  },
  {
    id: "lifecycle",
    icon: "ri-refresh-line",
    title: t("Узнайте, как жизненный цикл превращает потенциальных покупателей в клиентов"),
    text: t("Воронка показывает, на каком этапе продаж находится каждый контакт: этапы перетаскиваются, а стартовый и выигранный назначаются в один клик."),
    cta: t("Открыть жизненный цикл"),
    bullets: [t("Этапы под ваш процесс продаж"), t("Воронка и таблица строятся сами")],
    visual: false,
  },
  {
    id: "ai",
    icon: "ri-sparkling-line",
    title: t("Настройте AI-агентов, чтобы разгрузить команду"),
    text: t("AI Assist читает шаблоны и источники знаний компании и предлагает готовый ответ. Персону можно переписать под тон бренда и сразу проверить в тесте."),
    cta: t("Настроить AI Assist"),
    bullets: [t("Ответы по вашим документам"), t("Проверка черновика до отправки")],
    visual: false,
  },
  {
    id: "team",
    icon: "ri-team-line",
    title: t("Пригласите коллег работать с диалогами вместе"),
    text: t("Добавьте сотрудников по почте и выберите уровень доступа: агент видит свои диалоги, менеджер — все, администратор настраивает номера и ключи."),
    cta: t("Пригласить коллег"),
    bullets: [t("Приглашение приходит письмом"), t("Права задаются при добавлении")],
    visual: false,
  },
];

// каналы для иллюстрации в первом шаге
export const onboardingChannels = [
  { label: "WhatsApp", icon: "ri-whatsapp-line" },
  { label: "Telegram", icon: "ri-telegram-line" },
  { label: "Messenger", icon: "ri-messenger-line" },
  { label: "TikTok", icon: "ri-tiktok-line" },
  { label: t("Почта"), icon: "ri-mail-line" },
  { label: t("Звонки"), icon: "ri-phone-line" },
];

export const onboardingResources = [
  { id: "intro", icon: "ri-play-circle-line", label: t("Смотреть вводное видео по входящим") },
  { id: "support", icon: "ri-customer-service-2-line", label: t("Связаться с поддержкой") },
  { id: "demo", icon: "ri-calendar-check-line", label: t("Забронировать демо") },
  { id: "help", icon: "ri-question-line", label: t("Справочный центр") },
  { id: "guides", icon: "ri-file-video-line", label: t("Видеоинструкции") },
];

// мини-подсказки под окном
export const onboardingHints = [
  {
    icon: "ri-flag-2-line",
    title: t("Четыре шага до работы"),
    text: t("Пройдите чеклист один раз — и входящие, воронка и ассистент будут готовы к бою."),
  },
  {
    icon: "ri-progress-4-line",
    title: t("Прогресс считается сам"),
    text: t("Отметьте шаг выполненным — полоса прогресса и счётчик обновятся сразу."),
  },
  {
    icon: "ri-customer-service-line",
    title: t("Всегда есть куда обратиться"),
    text: t("Справа — ресурсы: вводное видео, поддержка, демо и справочный центр."),
  },
];